import * as fromDatatype from "../datatype-library/index";

export interface alg_bot_cf_message_link_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
  conversation_flow_guid: fromDatatype.GuidDataFieldInterface;
  message_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class alg_bot_cf_message_link_RowClass implements alg_bot_cf_message_link_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
  conversation_flow_guid: fromDatatype.GuidDataFieldInterface;
  message_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
